import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-统计看板",
  "use": "icon-统计看板-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-统计看板\">\n<g transform=\"translate(2 2) scale(0.75)\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"0.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t<path d=\"M2.5,3.2h11c0.6,0,1,0.4,1,1v8.1c0,0.6-0.4,1-1,1h-11c-0.6,0-1-0.4-1-1V4.2C1.5,3.6,1.9,3.2,2.5,3.2z\" />\n\t<path d=\"M1.5,5.3h13\" />\n\t<path d=\"M4.2,11.5V9.3\" />\n\t<path d=\"M6.7,11.5V7.4\" />\n\t<path d=\"M9.2,11.5V8.6\" />\n\t<path d=\"M11.7,11.5V6.8\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/统计看板.svg
// module id = 11Sr
// module chunks = 166